import { render, staticRenderFns } from "./PassportMainPage.vue?vue&type=template&id=c9a31858&scoped=true&"
import script from "./PassportMainPage.vue?vue&type=script&lang=js&"
export * from "./PassportMainPage.vue?vue&type=script&lang=js&"
import style0 from "./PassportMainPage.vue?vue&type=style&index=0&id=c9a31858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a31858",
  null
  
)

export default component.exports